export default "__VITE_ASSET__DguP9lj5__"